// extracted by mini-css-extract-plugin
export var Page = "page-module--Page--3W2zk";
export var Page__title = "page-module--Page__title--3QWkz";
export var Page__content = "page-module--Page__content--OHoBl";